import { styled, ToggleButton, toggleButtonClasses, ToggleButtonGroup, toggleButtonGroupClasses } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
    content: {
        padding: theme.spacing(2),
    },
    text: {
        marginTop: theme.spacing(2),
    },
    marginLeft: {
        marginLeft: theme.spacing(2),
    },

    formTitle: {
        marginBottom: theme.spacing(2),
    },
    formFormControl: {
        marginBottom: theme.spacing(3),
    },
    button: {
        width: 'fit-content',
        padding: '.8rem',
        paddingLeft: '1rem !important',
        paddingRight: '1rem !important',
        fontWeight: 'bold',
        border: '1px solid #e0e0e0',
        color: '#757575',
    },
}));

export const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    minWidth: 100,
    width: 'fit-content',
    height: 40,
    padding: theme.spacing(1.2, 2),
    fontWeight: 'bold',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
    textTransform: 'none',
    color: '#757575',
    '&.Mui-selected': {
        backgroundColor: '#e0e0e0 !important',
    },
}));

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
        minWidth: 100,
        width: 'fit-content',
        height: 40,
        padding: theme.spacing(1.2, 2),
        margin: theme.spacing(0.5),
        fontWeight: 'bold',
        borderRadius: '8px',
        textTransform: 'none',
        border: '1px solid #e0e0e0',
        color: '#757575',
        '&.Mui-selected': {
            backgroundColor: '#e0e0e0 !important',
        },
    },
}));
